import { Stack } from '@mui/material';
import * as React from 'react';
import { useDialerIsReady } from '../../../../store/dialer';
import { useAppSelector } from '../../../../store/hooks';
import { NavQuickCall } from '../../../Dialer/QuickCall/NavQuickCall';
import { NavAccountSetupButton } from '../NavAccountSetupButton';
import { UserEmailSetupButton } from '../UserEmailSetupButton';
import HeaderActionsCreateContact from './HeaderActionsCreateContact';
import HeaderActionsDialerStatus from './HeaderActionsDialerStatus';
import HeaderActionsScheduleMessages from './HeaderActionsScheduleMessages';

interface Props {
    onOpenDialogHandler: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function PageHeaderActions({ onOpenDialogHandler }: Props) {
    const dialerIsReady = useDialerIsReady();
    const twilioDeviceCount = useAppSelector(
        state => state.dialer.twilioDevice?.audioDevices.length || 0,
    );
    const isImpersonated = useAppSelector(state => state.user.isImpersonated);
    const isDialerBootstrapped = useAppSelector(state => state.dialer.isBootstrapped);

    return (
        <React.Fragment>
            <Stack direction="row" spacing={2}>
                <NavAccountSetupButton />
                <UserEmailSetupButton />
                <HeaderActionsCreateContact onOpenDialogHandler={onOpenDialogHandler} />
                {process.env.NODE_ENV === 'development' && <HeaderActionsScheduleMessages />}
                {dialerIsReady && <NavQuickCall isCompOnMenu={false} />}
                {(twilioDeviceCount < 1 || isImpersonated) && (
                    <HeaderActionsDialerStatus
                        isImpersonated={isImpersonated}
                        twilioDeviceCount={twilioDeviceCount}
                        isDialerBootstrapped={isDialerBootstrapped}
                    />
                )}
            </Stack>
        </React.Fragment>
    );
}
